import SweepRulesFull from './components/SweepRulesFull';
import { isControlFeatureEnabled } from 'owa-controls-feature-flags';
import * as React from 'react';
var SweepRulesOption = {
    key: 'sweepRules',
    titleStringKey: 'optionTitle_sweepRules',
    hideTitleInFullOptions: true,
    searchTermsStringKey: 'optionTitle_sweepRules',
    fullOptionFormSettings: {
        render: function () { return React.createElement(SweepRulesFull, null); },
        isDirty: function () { return false; },
        onSave: null,
        onDiscard: null,
        hideSaveDiscard: function () { return true; },
    },
    isHidden: function () { return !isControlFeatureEnabled('tri-sweep-options'); },
};
export default SweepRulesOption;
//# sourceMappingURL=SweepRulesOption.js.map